// Вспомогательная функция для подготовки данных аналитики
export const getModalClicksAnalytics = (otherParams: Record<string, string>) => {
  const pagePath = typeof window !== 'undefined' ? window.location.pathname : '';
  const pageUrl = typeof window !== 'undefined' ? window.location.href : '';
  const pageTitle = typeof window !== 'undefined' ? document.title : '';
  return {
    tariff_catalog_mobile: {
      page_url: pageUrl,
      page_path: pagePath,
      page_title: pageTitle,
      account_type: 'none',
      action: 'click',
      object_type: 'popup',
      ...otherParams,
    },
  };
};
